import { Box } from '@osmosis/react-ui/components/Box';
/* eslint-disable jsx-a11y/no-autofocus -- custom Modal prop focuses through react-focus-lock. */
import { Button } from '@osmosis/react-ui/components/Button';
import { Flex } from '@osmosis/react-ui/components/Box';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import Modal from './Modal';
import ActionBar from './ModalFooter';

export type ConfirmModalProps = {
  headerContent: ReactNode;
  headerColor?: string;
  headerBackground?: string;
  hide: () => void;
  isVisible: boolean;
  children: ReactNode;
  handleConfirm?: () => void;
  handleCancel?: () => void;
  confirmText?: string | ReactNode;
  cancelText?: string | ReactNode;
  showConfirm?: boolean;
};

/**
 * Returns ConfirmModal component.
 */
export const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    isVisible,
    hide,
    headerContent,
    headerColor,
    headerBackground,
    children,
    handleConfirm,
    handleCancel,
    confirmText,
    cancelText,
    showConfirm = true,
  } = props;

  return (
    <Modal
      autoFocus
      hasHeader={true}
      headerContent={headerContent}
      headerColor={headerColor}
      headerBackground={headerBackground}
      hide={hide}
      isVisible={isVisible}
      _className="absolute top-[50px] mx-[2px]"
    >
      <Box
        minWidth={['none', 'none', '600px']}
        data-testid="confirm-modal-container"
      >
        {children}
        <ActionBar>
          <Flex
            width="100%"
            justifyContent="flex-end"
            data-testid="confirm-modal-footer-container"
          >
            <Button
              data-testid="confirm-modal-footer-cancel"
              variant="outline"
              fontWeight="normal"
              color="gray50"
              px="20px"
              sx={{
                borderRadius: '50px',
              }}
              onClick={() => {
                handleCancel ? handleCancel() : hide();
              }}
            >
              {cancelText || (
                <FormattedMessage id="common.cancel" defaultMessage="Cancel" />
              )}
            </Button>
            {showConfirm && (
              <Button
                data-testid="confirm-modal-footer-ok"
                ml={3}
                color="textInvert"
                px="24px"
                sx={{
                  borderRadius: '50px',
                  backgroundColor: 'primary',
                }}
                onClick={handleConfirm}
                type="submit"
              >
                {confirmText || (
                  <FormattedMessage id="common.ok" defaultMessage="OK" />
                )}
              </Button>
            )}
          </Flex>
        </ActionBar>
      </Box>
    </Modal>
  );
};
